import {Factory} from '@infodata-group/inf-commons';
import {Application} from '../application';

export class ApplicationFactory implements Factory<Application> {

  build(o: any): Application {
    const app = new Application();
    app.id = o.id;
    app.label = o.label;
    app.shortLabel = o.shortLabel;
    app.description = o.description;
    app.iconMenu = o.iconFontAwesome?.split('fa-')[1];
    app.iconActive = o.iconActive;
    app.iconDisable = o.iconInactive;
    app.logoActive = o.logoActive;
    app.logoDisable = o.logoInactive;
    app.appType = o.appType;
    app.urlDoc = o.urlDoc;
    app.active = o.userAccesGranted;
    app.urlApp = o.urlApp;
    return app;
  }

  getApi(): string {
    return 'portail-apps';
  }
}
